import { useQuery } from '@tanstack/react-query'
import { api, type RevenueAnalyticsParams } from '@/lib/api-client'

/**
 * Fetch revenue analytics data for the Revenue tab
 * Includes daily/weekly/monthly trends, branch breakdown, category breakdown, and monthly comparison
 */
export function useRevenueAnalytics(params?: RevenueAnalyticsParams) {
  return useQuery({
    queryKey: ['analytics-revenue', params?.branchId, params?.startDate, params?.endDate, params?.groupBy],
    queryFn: () => api.analytics.revenue(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
